<template>
  <div data-luko-tracking="Page_uid">
    <section :class="$style.heroContainer" :style="`background-image:url(${picture.url})`">
      <Wrapper :class="$style.inner">
        <RichText :class="$style.title" :text-params="title" />
      </Wrapper>
    </section>
    <section :class="$style.container">
      <Wrapper :class="$style.innerSlices">
        <SlicesArea :slices="slices" />
      </Wrapper>
    </section>
    <section :class="$style.bottomSection"></section>
  </div>
</template>

<script>
import SlicesArea from '~/components/SlicesArea'
import { formatMetaDatas } from '~/utils/metaData'
import RichText from '~/components/RichText'

export default {
  head() {
    return formatMetaDatas(this.metaDatas, this.$route.path)
  },
  components: {
    SlicesArea,
    RichText,
  },
  async asyncData({ $prismic, store, params, app, error }) {
    try {
      const { data: document, alternate_languages } = await $prismic.api.getByUID('legal_page', params.uid, {
        lang: app.i18n.localeProperties.prismicIso,
      })

      store.dispatch('setAlternateLanguages', alternate_languages)

      // Force to set theme for navbar and footer
      store.commit('page/UPDATE', { primary: { theme: '2021Q4-pink' } })

      return {
        title: document.title,
        picture: document.hero_picture,
        slices: document.body,
        metaDatas: document.body1 || [],
      }
    } catch (e) {
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>

<style lang="scss" module>
.container {
  max-width: inherit;

  padding: 0 24px;
}

.heroContainer {
  max-width: inherit;
  margin: -64px 0 64px 0;

  padding: 0 24px;

  background-color: #fff4ee;
  background-repeat: no-repeat;
  background-position: bottom right;

  background-size: 660px;

  p {
    padding-bottom: 81px;

    color: $gray-700;
    font-size: 20px;
    line-height: 32px;
  }

  @include below(medium) {
    background-size: 300px;
  }
}

.inner {
  display: flex;

  min-height: 350px;
  padding-top: 144px;
}

.innerSlices {
  padding-bottom: 64px;
}

.title {
  max-width: 840px;

  h1 {
    max-width: 725px;
    margin-bottom: 16px;

    font-weight: 200;
    font-size: 32px;
    line-height: 48px;

    @include above(medium) {
      font-size: 52px;
      line-height: 64px;
    }
  }
}

.bottomSection {
  max-width: 100%;
  height: 419px;

  background: url('https://images.prismic.io/luko/a1fbc345-7436-419e-a70a-a141696c9395_LUKO_Homepage+Illustration_Mark+Conlan_Final+1.png?auto=compress,format');
  background-position: center bottom;
  background-size: cover;
}
</style>
